import type { FC } from 'react'
import React from 'react'

import { classNames } from '@/utils/helpers'

interface Props {
  label?: React.ReactNode
  className?: string
  fields: React.ReactNode[]
  htmlFor?: string
  error?: string
}

export const FormMultiFieldGroup: FC<Props> = ({
  label,
  className,
  fields,
  htmlFor,
  error,
}) => {
  return (
    <div className={classNames('flex flex-col gap-2 ', className)}>
      {label && (
        <label
          htmlFor={htmlFor}
          className="text-sm font-medium text-text-default"
        >
          {label}
        </label>
      )}
      <div className="flex max-w-fit items-center rounded-md bg-background">
        {fields.map((field, index) => (
          <React.Fragment key={index}>{field}</React.Fragment>
        ))}
      </div>
      {error && (
        <p className="whitespace-pre text-sm text-danger-default">{error}</p>
      )}
    </div>
  )
}
